import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

export const pageLoaderStyles = css`
  width: 100vw;
  height: 100vh;
  background: ${token('elevation.surface', '#fff')}};
  position: fixed;
  z-index: 2;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const logoStyles = css`
  transform: scale(0.6);
  @keyframes fading {
    0% {
    }
    50% {
      opacity: 0.75;
    }
    100% {
    }
  }
  animation: fading 1.5s linear infinite;
`;
